/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import moment from "moment";
import VPagination from "@hennge/vue3-pagination";
import jwt_decode from "jwt-decode";
import customModal from "../customModal/customModal.vue";
export default {
  name: "interimDataset",
  components: {
    VPagination,
    customModal,
  },
  async mounted() {
    this.defaultdate = localStorage.getItem("dateformat");
    this.idToken = store.getters.getIdToken;
    this.Headers = {
      headers: {
        Authorization: "Bearer " + this.idToken,
        "Content-Type": "application/json",
      },
    };
    window.addEventListener("studyIdChanged", (event) => {
      this.rollsprivilages = store.getters.getRolesprivilegeData;
      // this.listAudit();
      this.listinterimData();
      this.setToDefault();
    });
    this.rollsprivilages = await store.getters.getRolesprivilegeData;
    await this.listAllStudy();
    // await this.listAudit();
    await this.listinterimData();
    await this.fetchInterimVersions();
  },

  data() {
    return {
      baseUrl: process.env.VUE_APP_Service_URL,
      baseAPI: process.env.VUE_APP_Service_URL + "/management",
      baseDataAPI: process.env.VUE_APP_Service_URL + "/dataservices",
      fileStorageToken:
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJUeXBlIjoiU3RhdGljIiwiT3JnYW5pc2F0aW9uIjoiRGF0YW1hdGljYSIsImV4cCI6NDg5ODEzMDI2OH0._ousxF4A5Sh-aR85FkwcxcaqkPPDiAeeW3lS-WDlfZg",
      idToken: "",
      Headers: {},
      currentStudy: store.getters.getStudyIs,
      siteList: [],
      subjectList: [],
      visitList: [],
      files: [],
      studyList: [],
      aduitList: [],
      auditList: [],
      uploadedFile: null,
      validations: [false],
      selectedSite: "",
      selectedSubject: "",
      selsectedVisit: "",
      fileName: "",
      selectedStudy: "",
      fileId: "",
      disablePatient: true,
      rollsprivilages: "",
      pageNumber: 1,
      pageIndex: 1,
      pageSize: 10,
      currentPage: 1,
      SortProperty: "createdAt",
      SortOrder: "asc",
      auditData: {},
      search: {
        fromDate: "",
        toDate: "",
      },
      showSidePopup: {},
      auditpopup: false,
      openMapperModal: false,
      openSDTmModal: false,
      showLoading: false,
      errors: {
        sdtmVersion: "",
        sdtmVersionDuplicate: "",
      },
      adamdata: "",
      formData: {
        createdUserEmail: "",
        createdUserId: "",
        createdAt: "2025-02-27T05:20:58.540Z",
        lastModifiedUserEmail: "",
        lastModifiedUserId: "",
        lastModifiedAt: "2025-02-27T05:20:58.540Z",
        auditId: "",
        fileName: "",
        fileType: "",
        studyId: "",
        studyRef: "",
        domain: "",
      },
      intrimData: {
        interimVersion: "",
        studyId: "",
        comments: "",
      },
      interimVersions: [],
      errorMapper: [false],
      paginatedAuditList: [],
      totalItems: 0,
    };
  },
  computed: {
    versionList() {
      return this.auditList.map((field) => field.interimVersion);
    },
  },
  methods: {
    async getFiles() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseUrl}/forms-ml/sdtmtoadam/getadamtypes`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.files = res.data;
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async validateNull() {
      if (
        this.fileId != "" &&
        this.fileId !== null &&
        this.fileId !== undefined
      ) {
        this.validations[0] = false;
      } else {
        this.validations[0] = true;
      }
    },
    formatTime(timestamp) {
      return moment(timestamp).format("h:mm A");
    },

    async listAllStudy() {
      const usermail = jwt_decode(this.idToken).email;
      await axios
        .get(
          `${this.baseAPI}/study/getallstudy?user=${usermail}&api-version=1.0`,
          this.Headers
        )
        .then((res) => {
          this.studyList = res.data;
          console.log("Study list...", res);
        })
        .catch((err) => console.log("error in gettting Visit list", err));
    },

    // async listAudit() {
    //   const idtoken = store.getters.getIdToken;
    //   try {
    //     var isDes = this.SortOrder == 0 ? true : false;
    //     console.log("IS Descending is ", isDes);

    //     this.selectedStudy = store.getters.getStudyIs;

    //     const response = await axios.get(
    //       `${this.baseUrl}/forms/cdisc/listauditsdtm?StudyId=${this.selectedStudy}&pageindex=${this.pageIndex}&SortProperty=${this.SortProperty}&SortOrder=${this.SortOrder}&pagesize=${this.pageSize}`,
    //       {
    //         headers: {
    //           Authorization: `Bearer ${idtoken}`,
    //           "Content-Type": "application/json",
    //         },
    //       }
    //     );

    //     this.auditList = response.data.entities;
    //     this.totalItems = Math.ceil(response.data.totalCount / this.pageSize);
    //   } catch (error) {
    //     console.error("Error fetching audit list:", error);
    //   }
    // },

    async SiteChanged() {
      this.selectedSubject = "";
      await this.listSubjects();
      this.disablePatient = false;
    },
     SortSelected(sortProp, id) {
      console.log("SortPropChanged", sortProp, id);
      const selectedElement = document.getElementById(id);
      const selectedElementID = document.getElementById(id).id;
      if (sortProp != null && id == selectedElementID) {
        if (this.IsDesc == true) {
          if (selectedElement.classList.contains("sortDesc")) {
            return;
          } else if (selectedElement.classList.contains("sortAsc")) {
            selectedElement.classList.remove("sortAsc");
            selectedElement.classList.add("sortDesc");
          } else selectedElement.classList.add("sortDesc");
        } else {
          if (selectedElement.classList.contains("sortDesc")) {
            selectedElement.classList.remove("sortDesc");
            selectedElement.classList.add("sortAsc");
          } else if (selectedElement.classList.contains("sortAsc")) {
            return;
          } else selectedElement.classList.add("sortAsc");
        }
      } 
      this.pageIndex = 1;
      this.currentPage = 1;
      this.SortProperty = sortProp;
      this.SortOrder = this.SortOrder == 'desc' ? 'asc' : 'desc';
      this.listinterimData();
    },
    clearError(field) {
      if (this.errors[field]) {
        this.errors[field] = "";
      }
    },

    togglePopup(index) {
      this.showSidePopup = {
        ...this.showSidePopup,
        [index]: !this.showSidePopup[index],
      };
    },
    async setToDefault() {
      this.disablePatient = true;
      this.selsctedSite = "";
      this.selectedSubject = "";
      this.selsectedVisit = "";
      this.selectedStudy = "";
    },
    filter(data) {
      if (data) {
        return moment(data).format(this.defaultdate);
      }
    },
    loadPage: function(page) {
      this.currentPage = page;
      this.pageIndex = page;
      this.listinterimData();
    },

    async closemodallll() {
      this.auditpopup = false;
    },
    async opensdtmModal(auditdata) {
      await this.fetchInterimVersions();
      this.openSDTmModal = true;
      console.log("Converting SDTM to ADaM...", this.openSDTmModal);
    },

    sdtmclosemodal() {
      this.intrimData.sdtmVersion = "";
      this.intrimData.SdtmComments = "";
      this.intrimData.selectedDate = "";
      this.openSDTmModal = false;
    },
    async toggleInterimDataLock(audit) {
      this.selectedStudy = store.getters.getStudyIs;
      this.idToken = store.getters.getIdToken;
      const newStatus = audit.Islocked ? "unlock" : "lock";

      const payload = {
        id: audit._id,
        status: newStatus,
      };

      try {
        const res = await axios.put(
          `${this.baseUrl}/stats-python/toc/lockunlockinterimdataset`,
          payload,
          {
            headers: {
              Authorization: "Bearer " + this.idToken,
              "Content-Type": "application/json",
            },
          }
        );
        console.log("toggleInterimDataLock Response:", res.data);
        this.snapShot(audit.InterimVersion);
        this.listinterimData();
        //alert(`Interim data ${newStatus}ed successfully.`);
      } catch (err) {
        console.error(`Error in toggleInterimDataLock:`, err);
        alert(`Failed to ${newStatus} interim data.`);
      }
    },
    async fetchInterimVersions() {
      try {
        this.selectedStudy = store.getters.getStudyIs;
        const response = await axios.get(
          `${this.baseUrl}/forms/cdisc/listinterimversions`,
          {
            params: { studyId: this.selectedStudy },
            headers: {
              Authorization: `Bearer ${this.idToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.interimVersions = response.data || [];
      } catch (error) {
        console.error("Failed to fetch interim versions", error);
      }
    },
    async listinterimData() {
      const idtoken = store.getters.getIdToken;
      const page = this.currentPage || 1;
      const pageSize = this.pageSize || 10;
      const sortBy = this.SortProperty || "createdAt";
      const sortOrder = this.SortOrder;
      this.selectedStudy = store.getters.getStudyIs;

      try {
        const response = await axios.get(
          `${this.baseUrl}/stats-python/toc/statsinterimdata`,
          {
            params: {
              PageNumber: page,
              PageSize: pageSize,
              SortBy: sortBy,
              SortOrder: sortOrder,
              StudyId: this.selectedStudy,
            },
            headers: {
              Authorization: `Bearer ${idtoken}`,
              "Content-Type": "application/json",
            },
          }
        );

        this.auditList = response.data.result.Data || [];

        // Optional: Use the 'Total' field if needed
        this.totalItems = Math.ceil(response.data.result.Total / this.pageSize);
        console.log(" this.totalItems.......:", this.totalItems);

        // this.loadPage(this.currentPage);
      } catch (error) {
        console.error("Error fetching interim data:", error);
      }
    },

    async CreateInterimVersion() {
      if (!this.intrimData.sdtmVersion) {
        this.errors.sdtmVersion = "Please enter interim version";
      }

      if (this.errors.sdtmVersion) {
        return;
      }
      this.idToken = store.getters.getIdToken;
      this.selectedStudy = store.getters.getStudyIs;
      const payload = {
        studyid: this.selectedStudy,
        newinterimversion: this.intrimData.sdtmVersion,
        comment: this.intrimData.SdtmComments,
      };
      this.showLoading = true;

      console.log("Interim Data:", this.intrimData);
      try {
        const response = await axios.post(
          `${this.baseUrl}/stats-python/toc/createnewtocversion`,
          payload,
          {
            headers: {
              Authorization: "Bearer " + this.idToken,
              "Content-Type": "application/json",
            },
          }
        );
        console.log("Create Interim Version Response:", response.data);
        alert("Interim version created successfully.");
        this.showLoading = false;
        this.listinterimData();
        this.sdtmclosemodal();
        } catch (error) {
          console.error("Error creating interim version:", error);
          alert("Failed to create interim version.");
      }
    },
    async snapShot(interimVersion){
      const idtoken = store.getters.getIdToken;
      try {
              const response = await axios.get(
                `${this.baseUrl}/stats-python/toc/tocsnapshot?StudyId=${this.currentStudy}&InterimVersion=${interimVersion}`,
                {
                  headers: {
                    Authorization: `Bearer ${idtoken}`,
                    "Content-Type": "application/json",
                  },
                }
              );
              alert("Snapshot synced to eTMF successfully.");
            } catch (error) {
              console.error("Error fetching interim data:", error);
            }
    }
     
  },
};
